import Icon from 'veui/components/Icon'
import { IconCircleExtend } from 'dls-icons-vue'

Icon.register('circle-extend', IconCircleExtend)
